import React from "react";
import styled from "styled-components";
import { Button } from "../../atoms/Button";

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
};

export const SignOutForm: React.FC<Props> = ({ onCancel, onConfirm }) => (
  <FormContainer>
    <Title>Do you want to sign out?</Title>
    <ButtonRow>
      <Button text="Cancel" variant="border" onClick={onCancel} />
      <Button text="Sign out" variant="filled" onClick={onConfirm} />
    </ButtonRow>
  </FormContainer>
);

const FormContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.07);
  padding: 32px 40px;
  min-width: 340px;
  text-align: center;
`;

const Title = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #1a232f;
  margin-bottom: 32px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
`; 